require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.4@core-js/library/fn/object/assign.js
// module id = 68
// module chunks = 0